import React from 'react';

interface WarningModalProps {
  firstNm: string;
  lastNm: string;
  dob: string;
}

export function WarningModalContent({ firstNm, lastNm, dob }: WarningModalProps) {
  return (
    <p style={{ padding: '20px' }}>
      <span style={{ color: 'red' }}>Existing member:</span> A member with the name of <strong>{firstNm}</strong>{' '}
      <strong>{lastNm}</strong> and date of birth <strong>{dob}</strong> already exists. Continuing with this action may
      result in a duplicate entry. Are you sure you want to continue?
      <br />
      <br />
      If this was a mistake, please go back and search for the member. Adding an already existing member could result in
      billing issues.
    </p>
  );
}
